import React, { useState, useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box, Typography } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import { StatusControl } from "../../uiControls/statusControl";
import { DataSourceFileTypes } from "./dataSourceFileTypes";
import * as utils from "../../common/utils";

const initialDataSourceIsValid = {
  name: "",
  description: "",
  fileTypes: "",
};

export const DataSourceUpdate = (props) => {
  const {
    setUpdateOpen,
    dataSourceEdit,
    setDataSourceEdit,
    dataSourceAttributes,
  } = props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateDataSource } = useHttpRequests();
  const [selectedRows, setSelectedRows] = useState([]);

  const [dataSourceDetails, setDataSourceDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    dataSourceAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialDataSourceIsValid
  );

  const updateDataSourceDetailsValue = (_key, value) => {
    setDataSourceDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const onChangeHandler = (e, controlName) => {
    updateDataSourceDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };
  const cancelDataSourceHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setDataSourceEdit(false);
    setUpdateOpen(false);
  };

  const validateDataSourceDetails = () => {
    setIsValid(initialDataSourceIsValid);

    var errorSummary = "";

    if (!dataSourceDetails.name) {
      updateErrorMessage("name", "Data source", "Enter ");
      errorSummary += "Enter data source \n";
    } else if (!utils.isValidCharacters(dataSourceDetails.name)) {
      updateErrorMessage("name", "Data source", " has restricted characters");
      errorSummary += "Data source has restricted characters \n";
    }

    if (!dataSourceDetails.description) {
      updateErrorMessage("description", "Data source description", "Enter ");
      errorSummary += "Enter data source description \n";
    } else if (!utils.isValidCharacters(dataSourceDetails.description)) {
      updateErrorMessage(
        "description",
        "Data source Description",
        " has restricted characters"
      );
      errorSummary += "Data source description has restricted characters \n";
    }

    if (dataSourceDetails.active) {
      if (selectedRows?.length <= 0) {
        updateErrorMessage("fileTypes", "File type mapping required", "Enter ");
        errorSummary += "Missing file type mapping. \n";
      } else if (
        selectedRows?.filter((item) => item.rowToStartWith === "")?.length > 0
      ) {
        updateErrorMessage(
          "fileTypes",
          "Row to start with are required",
          "Enter "
        );
        errorSummary += "Missing row to start with \n";
      }
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      let dataObj = dataSourceDetails;
      dataObj["fileTypes"] = selectedRows?.map((c) => {
        return {
          fileTypeKey: c.fileTypeKey,
          rowToStartWith: c.rowToStartWith,
          active: c.active,
        };
      });

      const getUpdateDataSourceResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "Data source updated successfully!",
          })
        );
        setTimeout(() => {
          cancelDataSourceHandler();
        }, 2000);
      };

      if (dataSourceEdit) {
        updateDataSource(
          {
            url: "DataSources/" + dataObj["datasourceKey"],
            method: "PUT",
            body: dataObj,
          },
          getUpdateDataSourceResponse
        );
      } else {
        delete dataObj["dataSourceKey"];
        updateDataSource(
          { url: "DataSources", body: dataObj },
          getUpdateDataSourceResponse
        );
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            overflow: "auto",
          }}
        >
          <MessageDisplay />
          {!dataSourceEdit && (
            <>
              <InputText
                type="text"
                label="Data Source Name"
                id={"dataSourceDetails.name"}
                value={dataSourceDetails.name}
                onChange={(e) => onChangeHandler(e, "name")}
                isRequired={true}
                isError={isValid["name"] !== ""}
                charLength={50}
              />
              <InputText
                type="text"
                label="Data Source Description"
                id={"dataSourceDetails.description"}
                value={dataSourceDetails.description}
                onChange={(e) => onChangeHandler(e, "description")}
                isRequired={true}
                isError={isValid["description"] !== ""}
                charLength={50}
              />
            </>
          )}
          {dataSourceEdit && (
            <>
              <Typography>
                <label>Data Source Name:</label> {dataSourceDetails.name}
              </Typography>
              <Typography>
                <label>Data Source Description:</label>{" "}
                {dataSourceDetails.description}
              </Typography>
            </>
          )}

          <StatusControl
            label="Active"
            isRequired={false}
            fieldName={"active"}
            active={dataSourceDetails.active}
            updateStatusValue={updateDataSourceDetailsValue}
          />

          <DataSourceFileTypes
            setSelectedRows={setSelectedRows}
            rowExists={dataSourceAttributes?.fileTypes}
          />

          <SaveCancel
            cancelCall={() => cancelDataSourceHandler()}
            saveCall={() => validateDataSourceDetails()}
          />
        </div>
      </Box>
    </>
  );
};
